import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Home from '@/pages/Home';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: 'hsl(0 0% 8%)',
            border: '1px solid hsl(57 26% 84% / 0.15)',
            color: 'hsl(57 26% 84%)',
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
